export const query_rischio_fascicoli_anagrafiche_stats = `
query getFascicoloAnagraficheByTenantCountryStats($tenantId: String!, $aziendaId: Int!) {
  fascicolo(where: { TenantId: { _eq: $tenantId }, AziendaId: { _eq: $aziendaId } }) {
    Id
    anagrafica_fascicolos {
      anagrafica {
        AddrPaeseId
        AddrProvinciaId
        Cf
      }
    }
  }
}`;
export const query_ppe_fascicoli_anagrafiche_stats = `
query getFascicoloAnagraficheByTenantCountryStats($tenantId: String!,$aziendaId: Int!) {
  fascicolo(where: { TenantId: { _eq: $tenantId }, AziendaId: { _eq: $aziendaId } }) {
    Id
    anagrafica_fascicolos {
      anagrafica {
        IsPep
        IsNotPepMoreThanYear
        Cf
      }
    }
  }
}`;
export const query_prestazione_byTenant_Prest_stats = `
query getPrestByTenantPrestStats($tenantId: String!, $aziendaId: Int!) {
  prestazione(where: {
    fascicolo: {
      TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
      _or: [
        {_or: [{IsPrivate: {_eq: false}}]}
      ]
    }
  }) {
    base_tipo_prestazione {
      Rischio
    }
  }
}`;
export const query_rischio_byTenant_stats = `
query getRischioByTenantStats($tenantId: String!, $aziendaId: Int!) {
    rischio(where: {
        prestazione: {
            fascicolo: {
                TenantId: {_eq: $tenantId}, AziendaId: {_eq: $aziendaId},
                _or: [
                    {_or: [{IsPrivate: {_eq: false}}]}
                ]
            }
        }
    }, order_by: [{Id: desc}, {PrestazioneId: asc}, {ProvidedBy: asc}], distinct_on: [Id, PrestazioneId, ProvidedBy]) {
        EfTotale
    }
}`;